export enum AssetType {
  Invalid = 0,
  Image = 1,
  Video = 2,
  Audio = 3,
  Font = 4,
  Document = 5,
  Code = 6,
  Subtitles = 7,
  Folder = 8,
  Model3D = 9,
}

// AI-prefixed mirror enum for CreativeAssetType
export enum AIAssetType {
  Invalid = 'Invalid',
  Image = 'Image',
  Video = 'Video',
  Audio = 'Audio',
  Font = 'Font',
  Document = 'Document',
  Code = 'Code',
  Subtitles = 'Subtitles',
  Model3D = 'Model3D',
  Folder = 'Folder',
}

export enum CreativeAssetPurpose {
  FullAd = 0,
  Logo = 1,
  Banner = 2,
  CtaButton = 3,
  Icon = 4,
  Background = 5,
  Other = 6,
}

export enum AiCreativeAssetPurpose {
  FullAd = 'Full Ad',
  Logo = 'Logo',
  Banner = 'Banner',
  CtaButton = 'CTA Button',
  Icon = 'Icon',
  Background = 'Background',
  Other = 'Other',
}

export enum CreativeAssetsSource {
  TemplateAssets = 'TemplateAssets',
  BrandAssets = 'BrandAssets',
}
